const authorizeIP = async (ip, id, validateIP, envVariables) => {
  console.log("Authorizing IP:", ip);
  console.log("ID:", id);
  console.log("Validate IP:", validateIP);

  // Construct URL for initial authorization
  const url = `${envVariables.REACT_APP_ATLAS_AZFUNCTION}firewallrules/${ip}${envVariables.REACT_APP_ATLAS_AZFKEY_FRWRULES}`;
  console.log("Constructed URL:", url);

  try {
    // Try to authorize the IP first
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const text = await response.text();
    console.log("Raw response:", text);
    console.log("Response status:", response.status);
    console.log("Response headers:", response.headers);

    if (response.status === 204) {
      console.log("Received 204: No Content");
      return null;
    }

    if (text) {
      const result = JSON.tryParse(text);
      if (result === false) {
        // If authorization failed, try to add and authorize the IP
        const addAndAuthorizeUrl = `${envVariables.REACT_APP_ATLAS_AZFUNCTION}firewall/${ip}/${id}${envVariables.REACT_APP_ATLAS_AZFKEY_ADDFRW}`;
        console.log("Add and Authorize URL:", addAndAuthorizeUrl);

        const addResponse = await fetch(addAndAuthorizeUrl, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (addResponse.ok) {
          console.log("Successfully added and authorized the IP.");
          return true;
        } else {
          console.error("Failed to add and authorize the IP.");
          return false;
        }
      }
      return result; // Return initial result if it is true
    } else {
      console.error("Empty response received.");
      return false;
    }
  } catch (error) {
    console.error("An error occurred while authorizing the IP:", error);
    return false;
  }
};

export default authorizeIP;
